var _style, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";
import { forwardRef } from "react";

var SvgSmile = function SvgSmile(_ref, ref) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 72 72",
    style: {
      enableBackground: "new 0 0 72 72"
    },
    xmlSpace: "preserve",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill-rule:evenodd;clip-rule:evenodd;fill:#000000;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Branding"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    id: "cauze",
    transform: "translate(16.000000, 12.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "\\xFC",
    className: "st0",
    d: "M33.9,24.2l-0.7,4.1c-1.2,6.8-7.7,11.4-14.5,10.2S7.3,30.8,8.5,23.9l0.7-4.1l-16.5-2.9L-8,21 c-2.8,15.9,7.8,31.1,23.7,33.9c15.9,2.8,31.1-7.8,33.9-23.7l0.7-4.1L33.9,24.2z M47.5,7.5c-0.8,4.5-5.1,7.6-9.7,6.8 c-4.5-0.8-7.6-5.1-6.8-9.7C31.8,0,36.2-3,40.7-2.2S48.3,2.9,47.5,7.5z M18.7,2.4C17.9,6.9,13.5,10,9,9.2C4.4,8.4,1.4,4,2.2-0.5 s5.1-7.6,9.7-6.8S19.5-2.2,18.7,2.4z"
  }))))));
};

var ForwardRef = /*#__PURE__*/forwardRef(SvgSmile);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/smile.3e9227d6c9250db7e95d54340b950b53.svg";